import { render, staticRenderFns } from "./joinTeamDialog.vue?vue&type=template&id=628bed80&scoped=true&"
import script from "./joinTeamDialog.vue?vue&type=script&lang=js&"
export * from "./joinTeamDialog.vue?vue&type=script&lang=js&"
import style0 from "./joinTeamDialog.vue?vue&type=style&index=0&id=628bed80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bed80",
  null
  
)

export default component.exports